import { ACTION_TYPES } from './actionTypes'

export const detailSlipBillAction = (payload) => ({
	type: ACTION_TYPES.SET_DETAIL_SLIP_BILL,
	payload,
})
